// Monetization configuration.
//
// Sole-professional mode: no recurring subscriptions / no direct billing.
// Full access ("Pro") is granted by buying the book (Amazon) and redeeming the
// printed code; donations are a voluntary, off-platform gift.
//
// >>> EDIT THESE TWO URLs <<<
export const BOOK_URL = 'https://www.amazon.it/Sinergie-Generative-approccio-strutturato-prodotti/dp/B0D1P5R6WT';
export const DONATION_URL = 'https://ko-fi.com/';        // TODO: your Ko-fi / PayPal / BuyMeACoffee link

// Recurring Stripe subscriptions are disabled (kept in code for future use).
export const SUBSCRIPTIONS_ENABLED = false;
